module.exports = __webpack_public_path__ + "static/media/blur-04.4f6865d2.jpg";